export const GEO_KEYS = {
  main: 'geo-library',
};

export const geoQueryKeys = {
  geoLibrary: [GEO_KEYS.main],
};
